import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { digitalOcean } from "@/integrations/digitalocean/client";
import { Button } from "@/components/ui/button";
import { Music, ExternalLink, Lock } from "lucide-react";

export default function SpotifyPlaylists() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    if (!session) {
      navigate("/Auth");
      return;
    }
    const { data: profile } = await digitalOcean
      .from("profiles")
      .select("*")
      .eq("id", session.user.id)
      .single();
    setCurrentUser(profile);
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-8">
      <div className="text-center max-w-2xl">
        <div className="mb-6">
          <Music className="w-20 h-20 mx-auto text-primary mb-4" />
          <Lock className="w-10 h-10 mx-auto text-muted-foreground -mt-10 mb-6" />
        </div>
        <h1 className="text-4xl font-bold text-foreground mb-4">Spotify Playlist Submissions</h1>
        <p className="text-xl text-muted-foreground mb-8">
          Submit your tracks to curated Spotify playlists and reach a wider audience.
          Connect with playlist curators and grow your fanbase.
        </p>
        <div className="bg-card p-6 rounded-lg border border-border mb-8">
          <h3 className="text-lg font-semibold text-card-foreground mb-3">Coming Soon</h3>
          <p className="text-muted-foreground mb-4">
            We're building partnerships with Spotify playlist curators.
            This feature will be available soon!
          </p>
        </div>
        <div className="flex gap-4 justify-center">
          <Button onClick={() => navigate("/MyTracks")} tooltip="View all your uploaded tracks">View My Tracks</Button>
          <Button variant="outline" onClick={() => navigate("/Discover")} tooltip="Explore tracks from other artists">
            <ExternalLink className="w-4 h-4 mr-2" />
            Explore Tracks
          </Button>
        </div>
      </div>
    </div>
  );
}
